import BaseApiRequest from "./BaseApiRequest";
import { GET_ACCOUNT_DETAILS } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetAccountRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = `${GET_ACCOUNT_DETAILS}?t=${new Date().getTime()}`;

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
